export enum NotificationType
{
    StaffCaseloadAssignment = 1,
    StudentAssignment = 2
}
